module.exports = "/packs/media/images/icon-questions-b784656e369aabed81398d2deebd678f.png";